<button
    class="bg-deep-blue-50 hover:bg-[#d9d9df] transition-all duration-300 h-[60px] py-5 px-4 font-bold text-deep-blue-900"
    (click)="clicked.emit()"
>
    {{ label() | translate }}
</button>
